var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var ConjuntAparellsFilter = /** @class */ (function (_super) {
    __extends(ConjuntAparellsFilter, _super);
    function ConjuntAparellsFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = '';
        _this.descripcio = '';
        _this.horaInici = null;
        _this.horaFi = null;
        _this.labels['id'] = _this.i18n('Id');
        _this.labels['descripcio'] = _this.i18n('Descripció');
        _this.labels['horaInici'] = _this.i18n('Hora inici');
        _this.labels['horaFi'] = _this.i18n('Hora fi');
        return _this;
    }
    return ConjuntAparellsFilter;
}(FilterData));
export { ConjuntAparellsFilter };
